import { Tooltip, message } from 'antd';
import { ToolbarIcon } from '../ToolbarIcon';
import { useTranslate } from '@tolgee/react';
import { getShopeeInviteFollowerUrl } from 'services/api/conversation';
import useIM from 'hooks/business/im/useIM';

export interface ShopeeFollowProps {
  conversation: Conversation.Conversation;
  onSend?: () => void;
}

export const ShopeeFollow = (props: ShopeeFollowProps) => {
  const {
    conversation: { storeId, conversationId },
    onSend,
  } = props;
  const { t } = useTranslate();
  const { sendImage } = useIM();

  return (
    <Tooltip title={t('ViewsChat.邀请关注')}>
      <ToolbarIcon
        icon="follow"
        onClick={() =>
          getShopeeInviteFollowerUrl(storeId)
            .then((data) =>
              sendImage(conversationId, data, data.imgUrl, {
                followerMsg: true,
              }).finally(() => {
                onSend && onSend();
              }),
            )
            .catch(() => {
              message.error(t('phrase.获取数据失败，请稍后再试'));
            })
        }
      />
    </Tooltip>
  );
};
